"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemTag = void 0;
var _ItemTag = require("./ItemTag.styles");
var _jsxRuntime = require("react/jsx-runtime");
var ItemTag = function ItemTag(props) {
  var _props$isWithSpout = props.isWithSpout,
    isWithSpout = _props$isWithSpout === void 0 ? false : _props$isWithSpout,
    label = props.label;
  var styles = (0, _ItemTag.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Item__tag'],
    children: [isWithSpout && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Item__tag__spout']
    }), label]
  });
};
exports.ItemTag = ItemTag;